/* Barra de progreso hacia el regalo, dentro de la barra sticky de Vitals.
   La barra la pinta una app, así que NO tocamos su markup: insertamos un
   elemento propio dentro y lo re-insertamos si la app re-renderiza. */
(function () {
  var CFG = window.SDS_GIFT || {};
  var BAR = '.Vtl-StickyAddToCart';
  var total = CFG.cartTotal || 0;
  var loaded = false;

  var currency = CFG.cartCurrency || 'EUR';

  /* Liquid escapa el texto ("You&#39;re…"), y como lo pintamos con textContent
     el navegador no lo decodifica solo. Lo hacemos aquí. */
  function decode(str) {
    if (!str || str.indexOf('&') === -1) return str;
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }
  CFG.textAway = decode(CFG.textAway);
  CFG.textDone = decode(CFG.textDone);

  /* Formato correcto según la divisa que esté viendo el cliente. Antes ponía
     siempre "€" con coma decimal, así que en EE.UU. salía mal. */
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  /* El umbral está en moneda de la tienda; lo pasamos a la divisa activa. */
  function threshold() {
    var base = CFG.thresholdShopCents || 8500;
    var rate = 1;
    try { rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1; } catch (e) {}
    return base * rate;
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'sds-gp';
    el.innerHTML =
      '<div class="sds-gp__track"><div class="sds-gp__fill"></div></div>' +
      '<span class="sds-gp__label"></span>';
    return el;
  }

  function state() {
    var thr = threshold();
    var left = Math.max(0, thr - total);
    return {
      pct: Math.max(0, Math.min(100, (total / thr) * 100)),
      left: left,
      done: left <= 0,
      text: left <= 0 ? (CFG.textDone || 'Regalo desbloqueado')
                      : (CFG.textAway || 'Te faltan {amount}').replace('__AMT__', money(left))
    };
  }

  function render() {
    var st = state();

    /* a) dentro de la barra sticky de add-to-cart (solo en fichas) */
    var bar = document.querySelector(BAR);
    if (bar) {
      var gp = bar.querySelector('.sds-gp');
      if (!gp) { gp = build(); bar.appendChild(gp); }
      gp.querySelector('.sds-gp__fill').style.width = st.pct + '%';
      gp.classList.toggle('is-done', st.done);
      gp.querySelector('.sds-gp__label').textContent = st.text;
    }

    /* b) dentro del carrito (el markup ya está en cart-drawer.liquid) */
    var c = document.querySelector('[data-sds-gp-cart]');
    if (c) {
      c.hidden = !loaded || total <= 0;
      c.classList.toggle('is-done', st.done);
      c.querySelector('.sds-gpc__fill').style.width = st.pct + '%';
      c.querySelector('.sds-gpc__label').textContent = st.text;
    }
  }

  function refresh() {
    fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; currency = c.currency || currency; loaded = true; render(); })
      .catch(function () {});
  }

  /* la app puede re-pintar su barra: volvemos a meter la nuestra si desaparece */
  function watch() {
    var host = document.body;
    new MutationObserver(function () {
      var bar = document.querySelector(BAR);
      var c = document.querySelector('[data-sds-gp-cart]');
      if ((bar && !bar.querySelector('.sds-gp')) || (c && !c.dataset.sdsPainted)) {
        if (c) c.dataset.sdsPainted = '1';
        render();
      }
    }).observe(host, { childList: true, subtree: true });
  }

  /* cualquier cambio de carrito por los endpoints AJAX estándar */
  var of = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = of.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 400); }).catch(function () {});
    }
    return p;
  };

  /* el carrito se abre sin recargar la página, así que el total incrustado al
     renderizar se queda viejo: releemos /cart.js cada vez que se abre */
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var was = d.classList.contains('active');
    new MutationObserver(function () {
      var now = d.classList.contains('active');
      if (now && !now === false && now !== was) refresh();
      was = now;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.header__icon--cart, [href$="/cart"], cart-drawer')) setTimeout(refresh, 500);
    }, true);
  }

  function boot() { render(); refresh(); watch(); watchDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
